exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list__tile{padding:0 2em}.selected .list__tile__title{color:var(--primary_text)}.menu__content{margin-top:25px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/lang/ShortLangMenu.vue
// module id = 1090
// module chunks = 22